import lng from '@lightningjs/core';
import { Colors, Utils } from '@lightningjs/sdk';
import { Column, Row } from '@lightningjs/ui-components';
import AuthRoute from '../../../components/layouts/AuthRoute/AuthRoute';

//Components
import Button from '../../Settings/Exit/components/Button';

export const ExitOptions = [{ id: 1, title: 'Back' }];

export default class LockedDialog extends AuthRoute {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: Colors('#000000').get(),
      alpha: 0.9,
      Logo: {
        x: 740,
        y: 310,
        texture: lng.Tools.getSvgTexture(Utils.asset('/images/logo.png'), 438, 68),
      },
      Text: {
        y: 445,
        w: 1920,
        flex: { justifyContent: 'center', alignItems: 'center' },
        text: {
          textAlign: 'center',
          text: 'You need to purchase this film on the web app to watch it.',
          fontFace: 'OpenSans-Regular',
          color: Colors('#fafafa').get(),
        },
      },
      Row: {
        type: Row,
        collision: true,
        y: 550,
        flex: { justifyContent: 'center', alignItems: 'center' },
        items: ExitOptions.map((option, index) => ({
          index,
          collision: true,
          type: Button,
          option,
          color: Colors('#292929').get(),
        })),
      },
    };
  }

  get _Row() {
    return this.tag('Row');
  }

  _getFocused() {
    return this._Row;
  }
}
